module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/landing.component.css
// module id = ./src/app/landing/landing.component.css
// module chunks = main